<div class="form-review-gl">
  <ng-content></ng-content>
</div>
